//const EMPOWER_URL = "https://empower.indlava.com/";
const EMPOWER_URL = "https://empowerqrd.indlava.com/";
export const EMPOWER_LOGIN_URL = `${EMPOWER_URL}/login`;
export const EMPOWER_LOGOUT_URL = `${EMPOWER_URL}/login/logout`;
export const MAX_WEEK_NUM = 59;
